import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useMe } from '../context/MeContext';

/**
 * Route-level permission gate. Wrap inside ProtectedRoute:
 *
 *   <ProtectedRoute><RequirePermission anyOf={['role:view']}><Roles /></RequirePermission></ProtectedRoute>
 *
 * Without it, a deep link to an admin page renders the page and then fills with
 * 403s. The backend is still the authority — this only keeps the UI honest.
 *
 * @param anyOf     permission keys; holding any one is enough
 * @param platform  restrict to platform super-admins instead
 */
const RequirePermission = ({ anyOf = [], platform = false, children }) => {
  const { me, loaded, can, isPlatformAdmin } = useMe();

  if (!loaded) {
    return (
      <Box sx={{ p: 6, textAlign: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  const allowed = platform ? isPlatformAdmin : anyOf.some((p) => can(p));
  if (allowed) return children;

  // Send people somewhere useful: a platform admin with no clinic of their own
  // would only find an empty patient list.
  const fallback = isPlatformAdmin && !me?.tenant ? '/platform' : '/dashboard';
  return <Navigate to={fallback} replace />;
};

export default RequirePermission;
